import React, { useState } from "react";
import styles from './ServiceDockerhub.module.scss'
import Input from "../../../../../../../../../../../components/Input";
import ImgCDN from "../../../../../../../../../../../components/ImgCDN";

function ServiceDockerhub({app, update, messages}) {

    const [user, setUser] = useState(app.dockerhub_user);
    const [repo, setRepo] = useState(app.dockerhub_name);
    const [pass, setPass] = useState(app.dockerhub_password);

    const helpNamespaceRepository = (
        <div className={styles.help}>
            <p className={styles.help__text}>Get namespace and repository from image name, example:</p>
            <div className={styles.help__image}>
                <ImgCDN src='/images/builder/dockerhub-help-example.png' alt='Example'/>
            </div>
        </div>
    )

    return (
        <div>
            <p className={styles.title}>Dockerhub Image</p>
            <div className={styles.dockerhub}>
                <Input
                    className={styles.dockerhub__input}
                    id={`app-${app._id}-dockerhub-user`}
                    name='dockerhub_user'
                    placeholder='Namespace/User'
                    iconLeft='fas fa-user'
                    hint={helpNamespaceRepository}
                    hintType='modal'
                    maxLength={100}
                    isValid={messages.find(m => m.part === `app-${app._id}-dockerhub-user`) ? false : undefined}
                    error={messages.find(m => m.part === `app-${app._id}-dockerhub-user`)?.message}
                    value={user || ''}
                    onChange={e => {
                        const {value} = e.target;
                        update({dockerhub_user: value});
                        setUser(value);
                    }}
                />
                <Input
                    className={styles.dockerhub__input}
                    id={`app-${app._id}-dockerhub-name`}
                    name='dockerhub_name'
                    placeholder='Repository'
                    iconLeft='fas fa-file'
                    hint={helpNamespaceRepository}
                    hintType='modal'
                    maxLength={100}
                    isValid={messages.find(m => m.part === `app-${app._id}-dockerhub-name`) ? false : undefined}
                    error={messages.find(m => m.part === `app-${app._id}-dockerhub-name`)?.message}
                    value={repo || ''}
                    onChange={e => {
                        const {value} = e.target;
                        update({dockerhub_name: value});
                        setRepo(value)
                    }}
                    required
                />
                <Input
                    type='password'
                    className={styles.dockerhub__input}
                    id={`app-${app._id}-dockerhub-password`}
                    name='dockerhub_password'
                    placeholder='Password'
                    iconLeft='fas fa-lock'
                    maxLength={100}
                    isValid={messages.find(m => m.part === `app-${app._id}-dockerhub-pass`) ? false : undefined}
                    error={messages.find(m => m.part === `app-${app._id}-dockerhub-pass`)?.message}
                    value={pass || ''}
                    onChange={e => {
                        const {value} = e.target;
                        update({dockerhub_password: value});
                        setPass(value)
                    }}
                    autoComplete="new-password"
                />
            </div>
        </div>
    )
}

export default ServiceDockerhub